import { Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import TextFieldWithStyle from "../../../HOCs/InputWithStyle/InputWithStyle";

const LoyaltyAmountSetting = ({ onSubmit, name, label, defaultValues = 0 }) => {
	const { handleSubmit, register, setValue } = useForm({ defaultValues });

	useEffect(() => {
		if (defaultValues) setValue(name, defaultValues[name]);
	}, [setValue, defaultValues, name]);

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			style={{ border: "1px solid black", margin: "10px 0", width: "fit-content", padding: "2em", borderRadius: "5px" }}
		>
			<Typography variant="body2"> {label}</Typography>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				required
				fullWidth
				id={name}
				name={name}
				autoFocus
				type="number"
				inputRef={register({ required: true, min: 1 })}
			/>
			<br />
			<ButtonWithStyle onClick={handleSubmit(onSubmit)}>Guardar</ButtonWithStyle>
		</form>
	);
};

export default LoyaltyAmountSetting;
